var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Masz uprawnienia do zastępowania innego użytkownika")]),
      _vm._v(
        " Administrator udzielił Ci możliwości zalogowania w kontekście innego użytkownika. Jeśli chcesz możesz teraz przełączyć kontekst lub zrobić to później wybierając z menu Profil->Zastępstwa. "
      ),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  "append-icon": "search",
                  label: _vm.$t("global.search"),
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.substitutes,
          search: _vm.search
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.absent_user_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.from_date == null
                            ? "na czas nieokreślony"
                            : props.item.from_date
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.to_date == null
                            ? "na czas nieokreślony"
                            : props.item.to_date
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.comment))
                  ]),
                  _c(
                    "td",
                    { staticClass: "justify-center layout px-0" },
                    [
                      props.item.can_login_as
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mx-0",
                              attrs: {
                                icon: "",
                                disabled: _vm.$store.getters["Ajax/loading"]
                              },
                              on: {
                                click: function($event) {
                                  return _vm.loginAs(props.item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { color: "teal" } }, [
                                _vm._v("transfer_within_a_station")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.item.can_modify
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mx-0",
                              attrs: {
                                icon: "",
                                disabled: _vm.$store.getters["Ajax/loading"]
                              },
                              on: {
                                click: function($event) {
                                  return _vm.editItem(props.item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { color: "teal" } }, [
                                _vm._v("edit")
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.item.can_modify
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mx-0",
                              attrs: {
                                icon: "",
                                disabled: _vm.$store.getters["Ajax/loading"]
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteItem(props.item)
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { color: "pink" } }, [
                                _vm._v("delete")
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }